module.exports = __webpack_public_path__ + "static/media/1Asset-6Custom-Orders.87af56d8.png";